<script>
import {axios} from "../mixins";
import Modal from "./Modal.vue"
import Comments from "./Comments.vue"

export default {
  name: "Dashboard",

  mixins: [axios],

  components: {
    Comments,
    Modal
  },

  data() {
    return {
      filters: [],
      metrics: [],
      columns: [
        {'heading':'Column A'},
        {'heading':'Column B'},
      ],
      // Extra data that can be expanded from primary rows. Tableception.
      subColumns: [
        {'heading':'Sub Column A'},
        {'heading':'Sub Column B'}
      ],
      rows: [
        {
          'cols': [
            {'value':'Result 1'},
            {'value':'Result 2'}
          ],
          'subColumns': [
            {'value':'Sub result 1'},
            {'value':'Sub result 2'}
          ]
        }
      ],
      search: '',
      user: null,
      paginator: {
        'hasMorePages' : false,
        'hasPages' : false,
        'page' : 1,
        'lastPage' : 0,
      },
      loading: true,
      verificationModalData: null,
      verificationModalStatus: null,
    }
  },

  props: {
    resource: {
      // Determines what data is fetched from the controller
      // Ex. Field Visits, Contracts
      type: String,
      required: true
    },
    model: {
      // Specifies what model to update when patching
      type: String,
      required: false,
      default: 'contracts'
    },
    defaultUser: {
      type: Object,
      required: true
    },
    isSuper: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  created() {
    this.getRows()
    this.getMetrics()
  },

  methods: {
    getData() {
      this.getRows();
      this.getMetrics()
    },

    // Gets columns and rows for primary data table and filters
    getRows(page) {
      this.loading = true;
      let route = '/dashboard/data?resource=' + this.resource;

      this.paginator.page = page ?? 1;

      let data = {'filters': this.filters, 'paginator': this.paginator}

      this.get(route, {params: data}).then((response) => {
        this.rows = response.data.rows;
        this.columns = response.data.columns;
        this.subColumns = response.data.subColumns;
        this.filters = response.data.filters;
        this.paginator = response.data.paginator;
        this.loading = false;
      })
    },

    getMetrics() {
      let route = '/dashboard/data?type=Metrics&resource=' + this.resource;

      let data = {'filters': this.filters}

      this.get(route, {params: data}).then((response) => {
        this.metrics = response.data.metrics;
      })
    },

    // Gets rows to fill expandable row data
    getSubRows(row) {
      row.loading = true;
      let route = '/dashboard/data?type=SubData&modelID=' + row.id + '&resource=' + this.resource;

      let data = {'filters': this.filters}

      this.get(route, {params: data}).then((response) => {
        this.subColumns = response.data.subColumns;
        row.subRows = response.data.subRows;
        row.loading = false;
      })
    },

    // Map URL parameters
    urlParams(myData) {
      let out = [];
      for (let key in myData) {
        if (myData.hasOwnProperty(key)) {
          if (myData[key] !== null) {
            out.push(key + '=' + encodeURIComponent(myData[key]));
          }
        }
      }
      return out.join('&');
    },

    // Show or hide subcolumns for given row, and get subrows if needed
    toggleSubColumns(row) {
      row.expanded = !row.expanded;
      if (!row.subRows) {
        this.getSubRows(row);
      }
    },

    setColumnData(row, columnKey, value, model) {
      let data = {'data': {[columnKey]: value}};

      this.post('/dashboard/data?model=' + model + '&id=' + row.id, data).then((response) => {
        // success. what now? loading indicator -> success message?
      }).catch((errors) => {
        console.log(errors)
      });
    },

    openModal(modal, id, relation, index, subIndex, rowType, parent) {
      // Set modal data and open it
      // Index and rowType are used for callbacks, like giving visual feedback outside the modal itself
      if (modal === 'commentsModal') {
        let title = '';
        let subTitle = '';
        if (index !== null) {
          title = this.rows[index][parent]['text']
        }
        if (subIndex !== null) {
          subTitle = this.rows[index]['subRows'][subIndex]['name']['text']
        }
        console.log(title)
        console.log(subTitle)
        this.$refs['commentsModal'].setData(id, title, subTitle, relation, index, subIndex, rowType);
      }
      if (modal === 'verificationModal') {
        this.verificationModalStatus = null;
        this.verificationModalData = null;
        this.getVerificationModalData(id, index, subIndex)
        this.$refs['verificationModal'].open()
      }
    },

    updateColModifierKey(data) {
      if (data.rowType === 'rows') {
        this.rows[data.rowIndex][data.modifierKey] = data.value
      } else {
        this.rows[data.rowIndex]['subRows'][data.subRowIndex][data.modifierKey] = data.value
      }
    },

    getVerificationModalData(id, index, subIndex) {
      this.verificationModalData = 'loading';
      this.get('/dashboard/verification-data?id=' + id).then((response) => {
        this.verificationModalData = response.data.fieldVisit;
        if (this.verificationModalData !== false) {
          this.verificationModalData.contract = this.rows[index]['contract'];
          this.verificationModalData.field = this.rows[index]['subRows'][subIndex]['name']['text'];
          this.verificationModalData.get_id = id;
          this.verificationModalData.index = index;
          this.verificationModalData.subIndex = subIndex;
        }
      })
    },

    postVerificationModalData() {
      this.post('/dashboard/verification-data', this.verificationModalData).then((response) => {
        this.verificationModalStatus = true;
        this.getVerificationModalData(this.verificationModalData.get_id, this.verificationModalData.index, this.verificationModalData.subIndex);
      }).catch((errors) => {
        this.verificationModalStatus = false;
      })
    }
  }
}
</script>

<template>
  <div class="w-full p-4">

    <!--  FILTER SECTION  -->
    <div class="w-full flex flex-col mb-4">
      <div class="flex gap-2 my-auto w-full">
        <template v-for="(filter, index) in this.filters">
          <div v-if="filter.type === 'search'">
            <input type="text"
                   placeholder="Search..."
                   :id="filter.key"
                   v-model="this.filters[index].value"
                   class="bg-primary border border-grey-light w-full px-3 py-1 rounded leading-tight focus:outline-none">
          </div>
          <div v-else>
            <label hidden :for="filter.key">{{ filter.label }}</label>
            <select :name="filter.key"
                    :id="filter.key"
                    v-model="this.filters[index].value"
                    class="bg-primary italic border border-grey-light w-full px-3 py-1 rounded leading-tight focus:outline-none">
              <option :value="null">{{ filter.label }}</option>
              <template v-for="(option, index) in filter.options">
                <option :value="index">{{ option }}</option>
              </template>
            </select>
          </div>
        </template>
        <div>
          <button @click="getData()"
              class="rounded button button-wide text-white font-semibold bg-blue hover:bg-blue-dark focus:bg-blue-darker">
            Apply
          </button>
        </div>
      </div>
    </div>

    <!--  METRICS SECTION  -->
    <!-- This section dynamically creates a grid based on metrics modules added -->
    <div class="w-full bg-primary rounded tile-shadow my-2 grid "
         :class="this.metrics.length % 3 === 0 ? 'grid-cols-3' : 'grid-cols-4'">
      <template v-for="metric in this.metrics">
        <div class="bg-secondary text-center rounded-lg p-4 m-4">
          <h1 class="font-semibold text-xl">
            {{ metric.heading }}
          </h1>
          <span class="mt-2">
            {{ metric.value }}
          </span>
        </div>
      </template>
    </div>

    <!--  TABLE SECTION  -->
    <div class="bg-primary tile-shadow p-4 mt-4 rounded">
      <div class="overflow-x-scroll w-full">
        <div v-if="this.loading" class="w-full font-semibold text-xl text-center">
          Loading...
        </div>
        <table v-else class="overflow-auto whitespace-nowrap w-full">
          <thead>
            <tr class="bg-secondary rounded-t-lg text-left font-semibold">
              <td class="w-6"></td>
              <template v-for="col in columns">
                <td class="px-1">{{ col.heading }}</td>
              </template>
            </tr>
          </thead>
          <!-- NO DATA FOUND? SHOW THIS INSTEAD -->
          <template v-if="rows.length === 0">
            <tr>
              <td class="font-semibold text-xl text-center py-4" :colspan="this.columns.length + 1">No data found</td>
            </tr>
          </template>
          <!-- DATA FOUND? IT GETS SHOWN HERE -->
          <template v-for="(row, index) in this.rows">
            <tr :class="index % 2 === 0 ? `bg-primary` : `bg-secondary`">
              <td class="font-semibold hover:cursor-pointer w-6 text-center" @click="toggleSubColumns(row)">{{ row.expanded ? '-' : '+' }}</td>
              <template v-for="col in this.columns">
                <td class="px-1" :class="col.style">
                  <!-- SELECT COLUMN TYPE -->
                  <template v-if="col.type === 'select'">
                    <select :name="col.key" v-model="row[col.key]" @change="setColumnData(row, col.key, row[col.key], col.model)"
                            class=" w-full py-2 px-3 leading-tight focus:outline-none"
                            :class="index % 2 === 0 ? `bg-primary` : `bg-secondary`"
                    >
                      <option :value="null">-</option>
                      <template v-for="(option, index) in col.options">
                        <option :value="index">{{ option }}</option>
                      </template>
                    </select>
                  </template>
                  <!-- MODAL COLUMN TYPE -->
                  <template v-else-if="col.type === 'modal'">
                    <div @click="openModal(col.ref, row.id, col.relation, index, null, 'rows', col.parent)" class="font-semibold hover:cursor-pointer text-blue text-center">
                      Open <span v-if="row[col.modifierKey]" class="fas fa-comments"></span>
                    </div>
                  </template>
                  <!-- LINK COLUMN TYPE -->
                  <template v-else-if="(col.type === 'link' || col.type === 'link_hidden')">
                    <div class="px-1">
                      <span v-if="row[col.key]['href'] === ''">{{ row[col.key]['text'] ?? '-' }}</span>
                      <a :class="col.type === 'link' ? ` text-blue font-semibold hover:cursor-pointer` : ``"
                          :href="row[col.key]['href']" target="_blank">{{ row[col.key]['text'] }}</a>
                    </div>
                  </template>
                  <template v-else>
                    {{ row[col.key] }}
                  </template>
                </td>
              </template>
            </tr>

            <!-- SUB DATA SECTION -->
            <tr v-if="row.expanded">
              <td :colspan="(this.columns.length + 1)" class="p-0">
                <div v-if="row.loading" class="w-full font-semibold text-lg text-center bg-tertiary">
                  Loading...
                </div>
                <table v-else class="overflow-auto whitespace-normal w-full border-3 border-grey-darker">
                  <thead>
                    <tr class="bg-tertiary rounded-t-lg text-left font-semibold">
                      <td class="w-6"></td>
                      <template v-for="col in subColumns">
                        <td class="px-1" :class="col.style">{{ col.heading }}</td>
                      </template>
                    </tr>
                  </thead>
                  <template v-for="(subRow, subIndex) in row.subRows">
                    <tr class="border-b border-grey-darker bg-primary">
                      <td class="w-6"></td>
                      <template v-for="col in this.subColumns">
                        <!-- SELECT COLUMN TYPE -->
                        <template v-if="col.type === 'select'">
                          <select :name="col.key" v-model="subRow[col.key]" @change="setColumnData(subRow, col.key, subRow[col.key], col.model)"
                                  class=" w-full py-2 px-3 leading-tight focus:outline-none bg-primary">
                            <option :value="null">-</option>
                            <template v-for="(option, index) in col.options">
                              <option :value="index">{{ option }}</option>
                            </template>
                          </select>
                        </template>
                        <!-- MODAL COLUMN TYPE -->
                        <template v-else-if="col.type === 'modal'">
                          <td @click="openModal(col.ref, subRow.id, col.relation, index, subIndex, 'subRows', col.parent)" class="font-semibold hover:cursor-pointer text-blue text-center">
                            Open <span v-if="subRow[col.modifierKey]" class="fas fa-comments"></span>
                          </td>
                        </template>
                        <!-- LINK COLUMN TYPE -->
                        <template v-else-if="(col.type === 'link' || col.type === 'link_hidden')">
                          <td :class="`px-1` + ((col.type === 'link' && subRow[col.key]['href']) ? ` text-blue font-semibold` : ``)">
                            <span v-if="subRow[col.key]['href'] === ''">{{ subRow[col.key]['text'] ?? '-' }}</span>
                            <a v-else :href="subRow[col.key]['href']" target="_blank">{{ subRow[col.key]['text'] }}</a>
                          </td>
                        </template>
                        <!-- NORMAL AND BOOLEAN COLUMN TYPE -->
                        <td v-else class="px-1"
                            :class="col.style ? col.style : ''
                              + ((col.type === 'boolean' && subRow[col.key] === 'False') ? ` text-white bg-red` : ``)">
                          {{ subRow[col.key] }}
                        </td>
                      </template>
                    </tr>
                  </template>
                </table>
              </td>
            </tr>
          </template>
        </table>
        <div class="w-full grid grid-cols-3 mt-4" v-if="this.paginator.hasPages && !this.loading">
          <div class="text-left">
            <button v-if="this.paginator.page > 1"
                    @click="this.getRows(this.paginator.page - 1)"
                    class="px-6 py-2 rounded-md inline-block shadow-lg bg-blue hover:bg-blue-dark focus:bg-blue-darker font-bold">
              Previous
            </button>
            <span v-else> </span>
          </div>

          <span class="font-semibold py-2 text-center">Page {{ this.paginator.page }} of {{ this.paginator.lastPage }}</span>

          <div class="text-right">
            <button v-if="this.paginator.hasMorePages"
                    @click="this.getRows(this.paginator.page + 1)"
                    class="px-6 py-2 rounded-md  inline-block shadow-lg bg-blue hover:bg-blue-dark focus:bg-blue-darker font-bold">
              Next
            </button>
            <span v-else> </span>
          </div>
        </div>
      </div>
    </div>

    <!-- COMMENT MODAL -->
    <Comments ref="commentsModal"
              @updateColModifierKey="this.updateColModifierKey"
    >
    </Comments>

    <!-- FIELD VERIFICATION INTERACTION MODAL -->
    <Modal ref="verificationModal" :large="true">
      <div v-if="this.verificationModalData" class="w-full">
        <div class="p-2">
          <a target="_blank"
              :href="this.verificationModalData.contract.href"
              class="text-xl font-semibold hover:cursor-pointer text-blue">
            {{ this.verificationModalData.contract.text }}
          </a>

          <p class="text-lg">{{ this.verificationModalData.field }}</p>

          <p class="text-sm italic text-grey-light">Compliance values denoted with an asterisk have been manually set.</p>
        </div>

        <div class="flex flex-col max-h-[66vh] overflow-y-scroll p-2 gap-2">
          <template v-for="compliance in verificationModalData.data_fields">
            <div class="p-2 bg-secondary rounded">
              <div>
                <span class="font-semibold">
                  {{ compliance[0] }} -
                </span>
                <span :class="this.verificationModalData[compliance[1]] ? 'text-green' : 'text-red'">
                  {{ this.verificationModalData[compliance[1]] ? 'Compliant' : 'Not Compliant' }} {{ this.verificationModalData[compliance[5]] ? '*' : ''}}
                </span>

                <span v-if="this.isSuper" class="button float-right py-0 px-1 text-sm inline-block bg-primary border-blue hover:bg-grey-lightest focus:bg-grey-lighter"
                      @click="this.verificationModalData[compliance[6]] = !this.verificationModalData[compliance[6]]">
                  <span v-show="!this.verificationModalData[compliance[6]]">
                    <span><i class="fas fa-pen-to-square"></i></span>
                    <span class="ml-1">Edit</span>
                  </span>
                  <span v-show="this.verificationModalData[compliance[6]]">
                    <i class="fas fa-xmark"></i>
                    <span class="ml-1">Cancel</span>
                  </span>
                </span>
              </div>

              <div class="whitespace-pre-line">
                Current Notes - {{ this.verificationModalData[compliance[2]] ?? 'None' }}
              </div>

              <div v-show="this.verificationModalData[compliance[6]]">
                <select class="bg-primary mb-1 italic border border-grey-light px-3 py-1 rounded leading-tight focus:outline-none"
                        :required="this.verificationModalData[compliance[6]]"
                        v-model="this.verificationModalData[compliance[3]]">
                  <option :value="null">
                    Select Compliance Status...
                  </option>
                  <option :value="true">
                    Compliant
                  </option>
                  <option :value="false">
                    Not Compliant
                  </option>
                </select>
                <textarea type="text"
                          rows="2"
                          placeholder="Notes..."
                          v-model="this.verificationModalData[compliance[4]]"
                          class="bg-primary border border-grey-light w-full px-3 py-1 rounded leading-tight focus:outline-none resize-none">
                </textarea>
              </div>
            </div>
          </template>
        </div>
      </div>

      <div v-else-if="this.verificationModalData === 'loading'" class="w-full text-center font-bold p-2">
        Loading...
      </div>

      <div v-else class="w-full text-center font-bold p-2">
        No visit found!
      </div>

      <template #toggle="{open}"></template>
      <template #footer="{cancel}">
        <button type="button"
                class="button button-wide text-white bg-green hover:bg-green-dark focus:bg-green-darker font-bold"
                @click="postVerificationModalData()">
          Save
        </button>
        <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
          <button type="button"
                  class="button button-wide bg-secondary hover:bg-grey-lightest focus:bg-grey-lighter font-bold mr-2"
                  v-on:click="cancel">
            Close
          </button>
        </span>

        <div v-show="this.verificationModalStatus"
             :class="'px-6 py-1 flex justify-center my-auto mx-1 font-bold '
           + (this.verificationModalStatus ? 'text-green' : 'text-red')">
          {{ this.verificationModalStatus ? 'Success! If the future crop type is non-compliant, your notes have still been saved.' : 'Error!' }}
        </div>
      </template>
    </Modal>
  </div>
</template>
